import api from './axios';

export const verificationApi = {
  // Get my own verification status (provider only)
  getMyVerification: () =>
    api.get('/provider/verification').then((r) => r.data),

  // Submit an uploaded URL for a given document type
  submitDocument: ({ type, url, originalName, mimeType }) =>
    api
      .patch('/provider/verification/documents', { type, url, originalName, mimeType })
      .then((r) => r.data),

  // Remove a not-yet-approved document
  removeDocument: (type) =>
    api.delete(`/provider/verification/documents/${type}`).then((r) => r.data),

  /**
   * Upload a file. `kind` controls the S3 folder:
   *   'avatar' | 'id' | 'insurance' | 'general'
   * Returns: { success, url, key, file_type, file_format, name, mime_type, size, kind }
   */
  uploadFile: (file, { kind = 'general', onProgress } = {}) => {
    const form = new FormData();
    form.append('binary_file', file);
    form.append('kind', kind);
    return api
      .post('/upload-files', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (onProgress && e.total) {
            onProgress(Math.round((e.loaded / e.total) * 100));
          }
        },
      })
      .then((r) => r.data);
  },
};